import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import SEO from "@/components/site/SEO";
import { useReveal } from "@/hooks/useReveal";

export default function Standorte() {
  useReveal();
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Standorte – Finanzberatung in ganz Deutschland | FINABLE"
        description="FINABLE berät Dich digital in ganz Deutschland – von Berlin bis München, von Hamburg bis Freiburg. 100% digital, unabhängig und kostenlos."
        canonical="https://finable.de/standorte"
      />
      <Header />
      <main>
        <section className="pt-32 md:pt-40 pb-16 bg-gradient-hero text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-radial pointer-events-none" />
          <div className="container relative max-w-3xl text-center">
            <span className="reveal inline-block text-accent font-semibold uppercase tracking-wider text-sm">
              Standorte
            </span>
            <h1 className="reveal mt-4 font-display text-4xl md:text-6xl font-extrabold text-balance leading-[1.05]">
              Finanzberatung in <span className="text-accent">ganz Deutschland</span>
            </h1>
            <p className="reveal mt-6 text-lg md:text-xl text-white/85">
              Wir beraten Dich 100% digital, unabhängig und kostenlos – egal wo Du in Deutschland lebst.
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background">
          <div className="container max-w-5xl">
            <div className="reveal text-center mb-10">
              <div className="flex items-center justify-center gap-2 mb-4">
                <MapPin className="w-5 h-5 text-accent" />
                <span className="font-display text-xl font-bold text-primary">Deutschlandweit verfügbar</span>
              </div>
              <p className="text-muted-foreground max-w-2xl mx-auto">
                Du brauchst keinen Termin vor Ort. Alles läuft digital per Video und App. Wähle Deine Stadt:
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 reveal">
              {[
                { name: "Berlin", slug: "berlin" },
                { name: "Hamburg", slug: "hamburg" },
                { name: "München", slug: "muenchen" },
                { name: "Köln", slug: "koeln" },
                { name: "Frankfurt", slug: "frankfurt" },
                { name: "Stuttgart", slug: "stuttgart" },
                { name: "Düsseldorf", slug: "duesseldorf" },
                { name: "Leipzig", slug: "leipzig" },
                { name: "Dortmund", slug: "dortmund" },
                { name: "Essen", slug: "essen" },
                { name: "Bremen", slug: "bremen" },
                { name: "Dresden", slug: "dresden" },
                { name: "Hannover", slug: "hannover" },
                { name: "Nürnberg", slug: "nuernberg" },
                { name: "Duisburg", slug: "duisburg" },
                { name: "Bochum", slug: "bochum" },
                { name: "Wuppertal", slug: "wuppertal" },
                { name: "Bielefeld", slug: "bielefeld" },
                { name: "Bonn", slug: "bonn" },
                { name: "Münster", slug: "muenster" },
                { name: "Mannheim", slug: "mannheim" },
                { name: "Karlsruhe", slug: "karlsruhe" },
                { name: "Augsburg", slug: "augsburg" },
                { name: "Wiesbaden", slug: "wiesbaden" },
                { name: "Gelsenkirchen", slug: "gelsenkirchen" },
                { name: "Aachen", slug: "aachen" },
                { name: "Braunschweig", slug: "braunschweig" },
                { name: "Kiel", slug: "kiel" },
                { name: "Chemnitz", slug: "chemnitz" },
                { name: "Halle", slug: "halle" },
                { name: "Magdeburg", slug: "magdeburg" },
                { name: "Freiburg", slug: "freiburg" },
                { name: "Krefeld", slug: "krefeld" },
                { name: "Mainz", slug: "mainz" },
                { name: "Lübeck", slug: "luebeck" },
                { name: "Erfurt", slug: "erfurt" },
                { name: "Oberhausen", slug: "oberhausen" },
                { name: "Rostock", slug: "rostock" },
                { name: "Kassel", slug: "kassel" },
                { name: "Hagen", slug: "hagen" },
                { name: "Hamm", slug: "hamm" },
                { name: "Saarbrücken", slug: "saarbruecken" },
                { name: "Mülheim", slug: "muelheim" },
                { name: "Potsdam", slug: "potsdam" },
                { name: "Osnabrück", slug: "osnabrueck" },
                { name: "Heidelberg", slug: "heidelberg" },
                { name: "Darmstadt", slug: "darmstadt" },
                { name: "Regensburg", slug: "regensburg" },
                { name: "Ingolstadt", slug: "ingolstadt" },
                { name: "Würzburg", slug: "wuerzburg" },
                { name: "Ulm", slug: "ulm" },
                { name: "Heilbronn", slug: "heilbronn" },
                { name: "Pforzheim", slug: "pforzheim" },
                { name: "Wolfsburg", slug: "wolfsburg" },
                { name: "Offenbach", slug: "offenbach" },
                { name: "Göttingen", slug: "goettingen" },
                { name: "Bottrop", slug: "bottrop" },
                { name: "Recklinghausen", slug: "recklinghausen" },
                { name: "Bremerhaven", slug: "bremerhaven" },
                { name: "Fürth", slug: "fuerth" },
                { name: "Remscheid", slug: "remscheid" },
                { name: "Reutlingen", slug: "reutlingen" },
                { name: "Solingen", slug: "solingen" },
                { name: "Siegen", slug: "siegen" },
                { name: "Mönchengladbach", slug: "moenchengladbach" },
                { name: "Koblenz", slug: "koblenz" },
                { name: "Bergisch Gladbach", slug: "bergisch-gladbach" },
                { name: "Erlangen", slug: "erlangen" },
                { name: "Trier", slug: "trier" },
                { name: "Jena", slug: "jena" },
                { name: "Salzgitter", slug: "salzgitter" },
                { name: "Hildesheim", slug: "hildesheim" },
                { name: "Gütersloh", slug: "guetersloh" },
                { name: "Zwickau", slug: "zwickau" },
                { name: "Paderborn", slug: "paderborn" },
                { name: "Kaiserslautern", slug: "kaiserslautern" },
                { name: "Schwerin", slug: "schwerin" },
                { name: "Oldenburg", slug: "oldenburg" },
                { name: "Neuss", slug: "neuss" },
                { name: "Leverkusen", slug: "leverkusen" },
                { name: "Flensburg", slug: "flensburg" },
                { name: "Ludwigshafen", slug: "ludwigshafen" },
                { name: "Cottbus", slug: "cottbus" },
                { name: "Iserlohn", slug: "iserlohn" },
                { name: "Dessau", slug: "dessau" },
                { name: "Viersen", slug: "viersen" },
                { name: "Konstanz", slug: "konstanz" },
                { name: "Herford", slug: "herford" },
                { name: "Lünen", slug: "luenen" },
                { name: "Villingen-Schwenningen", slug: "villingen-schwenningen" },
                { name: "Wilhelmshaven", slug: "wilhelmshaven" },
                { name: "Bamberg", slug: "bamberg" },
                { name: "Landshut", slug: "landshut" },
                { name: "Bocholt", slug: "bocholt" },
                { name: "Gera", slug: "gera" },
                { name: "Marburg", slug: "marburg" },
                { name: "Minden", slug: "minden" },
                { name: "Moers", slug: "moers" },
              ].map((c) => (
                <Link
                  key={c.slug}
                  to={`/finanzberatung-${c.slug}`}
                  className="flex items-center justify-center gap-2 rounded-xl border bg-card px-4 py-3 font-medium text-primary hover:border-accent hover:text-accent transition-colors"
                >
                  <MapPin className="w-4 h-4" />
                  {c.name}
                </Link>
              ))}
            </div>
            <div className="reveal mt-10 text-center">
              <Link
                to="/leistungen"
                className="inline-flex items-center gap-2 rounded-xl bg-accent text-white px-6 py-3 font-semibold hover:bg-accent/90 transition-colors"
              >
                Unsere Leistungen entdecken
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
